<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
        <AmountSelectorListTeachFlVendors />
          <FormSection title="Vendor Registration">
            <FormRow inline>
              <div style="width: 100%">
                <FormLabel class="control-label">
                  Business Name
                </FormLabel>
                <FormInput type="text" class="width-half" field="custom.businessName" />
                <ErrorLabel field="custom.businessName" />

              </div>
            </FormRow>

            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>

            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
          </FormSection>
        <FormSection title="">
            <DonorAddress />
          </FormSection>
          <FormSection title="">
            <div>
              <div>
                <FormRow inline>
                  <FormCol field="custom.subjectCategory" width="half" :showLabel="false">
                    <FormLabel class="control-label">Subject Category: </FormLabel>
                    <FormSelect>
                      <option value="ESSA/ Title Program">ESSA/ Title Program</option>
                      <option value="IDEA/ Special Education Services">IDEA/ Special Education Services</option>
                      <option value="Security">Security</option>
                      <option value="Professional Learning/ Coaching">Professional Learning/ Coaching</option>
                      <option value="Other">Other</option>                     
                    </FormSelect>
                  </FormCol>
                </FormRow>
              </div>
            </div>
          </FormSection>
      
          <FormSection title="Payment Options">
            <div class="frequency">
              <PaymentOptions addSplit :splitMonths="12" />
            </div>
          </FormSection>

          
          <FormSection title="Payment Information" last>
            <div class="payment-info">
              <FormRow>
                <PaymentType
                  cc_text="Credit Card"
                  check_text="Check / Donor Advised Fund"
                />
              </FormRow>
              <FormRow inline>
                <FormCol
                  class="doublepay"
                  field="card"
                  :showLabel="false"
                  check_text=""
                />
              </FormRow>
              <FormRow
                v-if="form.gateway === 'check'"
                style="justify-content: center"
                class="checktext"
              >
                <div>
                  Please mail your check to the following address:
                  <p style="text-align: center">
                    <strong
                      >Teach Florida<br />
                      C/O Caleb Fischer<br />
                      3107 Stirling Rd, STE 308<br />
                      Ft Lauderdale, FL 33312</strong
                    >
                  </p>
                </div>
              </FormRow>
            </div>
          </FormSection>
          <PaymentButton showAmount btnText="Pay now" />
          <p class="note">
            <br />All donations are tax-deductible to the full extent permitted by law.
          </p>
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  onMounted,
  ref,
  watch,
  computed,
} from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  props: {
    subCampaign: String,
    campaign: String,
  },
  setup(props) {
    const { setValue, form, getValue, submit } = usePaymentForm();
    setValue("custom.booth", "yes");
    setValue("custom.presentSession", "yes");
    setValue("amount", "2500");


    return {
      form,
      setValue,
      getValue,
      submit,
    };
  },
});
</script>
<style scoped lang="scss">
.form-container.ou-donation-form {
  margin: 0px;
  padding: 0px;
  box-shadow: none;
  max-width: 100%;
}
h2 {
  font-weight: 600;
  margin-bottom: 20px;
  margin-top: 0px;
  font-size: 20px;
  color: black;
}
.selcted__note {
  border: none;
}
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.note {
  font-style: italic;
  line-height: 1.4;
  font-weight: 500;
  font-size: 14px;

  a {
    text-decoration: none;
  }
}
::v-deep .amount-row {
  min-width: 100% !important;
  max-width: 100% !important;
  //   @media (min-width: 720px) {
  // min-width: 48% !important;
  // max-width: 48% !important;
  //   }
  &.amount-row--wide {
    min-width: 65% !important;
    max-width: 65% !important;
  }
}

::v-deep label {
  line-height: normal !important;
}
::v-deep .styled-radio-container--ou-donation.styled-radio-container {
  gap: 2%;
  justify-content: flex-start;

  label {
    font-weight: 500;
    background: #122d3d !important;
    color: white !important;
    display: flex !important;
    line-height: normal;
    &:hover {
      background: black !important;
    }
  }
  input[type="radio"]:checked + label {
    background: #be9e5f !important;
  }

  textarea {
    padding: 5px 10px;
    font-family: inherit;
  }
  .label-description {
    background: none !important;
    display: block !important;
    text-align: center !important;
    font-size: 17px;
    font-style: italic;
    padding-top: 0;
    color: white !important;
  }
  .label-amount {
    background: none !important;
    display: block !important;
    height: auto !important;
    max-width: 100%;
    min-width: 100% !important;
    border: none !important;
    font-size: 18px;
    text-align: center;
  }
  #amount_other {
    max-width: 100%;
  }
  .amount_other__wrapper::before {
    background: #122d3d !important;
    color: white !important;
    font-weight: bold;
  }
  .amount_other__wrapper {
    margin-bottom: 18px;
  }
}

.radio-part {
  display: flex;
  gap: 10px;
  align-items: center;
  padding-bottom: 5px;
}
.radio-part label {
  margin: 0px;
  padding: 0px;
  line-height: normal;
}
.payment-info {
  p {
    margin-bottom: 20px;
  }
}

.designation-form-row.form-group.rowidth__full {
  flex-flow: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
}



::v-deep .flex span {
  display: flex;
}
</style>